// extracted by mini-css-extract-plugin
export const solidButton = "button-module--solidButton--874Io";
export const linkButton = "button-module--linkButton--Shx8h";
export const textButton = "button-module--textButton--mRLqm";
export const underlinedButton = "button-module--underlinedButton--2j6qJ";
export const outlinedButton = "button-module--outlinedButton--1_H-3";
export const noChildren = "button-module--noChildren--3GhBq";
export const small = "button-module--small--2Jtoi";
export const normal = "button-module--normal--3k5G3";
export const large = "button-module--large--1rP8r";
export const disabled = "button-module--disabled--19lQz";
export const quantityButton = "button-module--quantityButton--2QIT5";
export const hasActionButton = "button-module--hasActionButton--15ioU";
export const success = "button-module--success--9zEAP";
export const warn = "button-module--warn--3qmF2";